export const MERCHANT_ADMIN_MEMBER_DETAILS = {
    CLICKABLE_LOGO: "clickable-logo",
    LOGO_EDIT_DIALOG_CONTENT: "logo-edit-dialog-content",
    MEMBER_NAME: "member-name",
    MEMBER_TITLE_INPUT: "member-title-input",
    PHONE_INPUT: "phone-input",
    MOBILE_INPUT: "mobile-input",
    EMAIL_INPUT: "email-input",
    EMPLOYEE_CODE_INPUT: "employee-code-input",
    SAVE_BUTTON: "save-button",
    ACTION_SUCCESS_MESSAGE: "action-success-message",
    ACTION_ERROR_MESSAGE: "action-error-message",
    ERROR_MESSAGE_BAR: "error-message-bar",
    MORE_MENU: "more-menu",
    MORE_MENU_SET_INACTIVE: "more-menu-set-inactive",
    MORE_MENU_SET_ACTIVE: "more-menu-set-active",
    MEMBER_DEACTIVATED_MESSAGE_BAR: "member-deactivated-message-bar",
};
